export class WorkingHours {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.activityId = params.activity_id ? params.activity_id : null
    this.startDate = params.start_date ? params.start_date : null
    this.endDate = params.end_date ? params.end_date : null
    this.availableHours = params.available_hours ? params.available_hours.map((item) => {
      return new AvailableHours(item)
    }) : []
  }
}
export class AvailableHours {
  constructor (params = {}) {
    this.dow = params.dow
    this.startHour = params.start_hour
    this.endHour = params.end_hour
  }
}
